/* eslint-disable no-shadow */
/* eslint-disable no-debugger */
/* eslint-disable no-else-return */
/* eslint-disable no-console */
/* eslint-disable no-useless-return */
/* eslint-disable react/button-has-type */
/* eslint-disable dot-notation */
/* eslint-disable react/self-closing-comp */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-const */
/* eslint-disable no-var */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-use-before-define */
/* eslint-disable array-callback-return */
/* eslint-disable camelcase */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@material-ui/core";
import axios from "axios";
import WarningIcon from "@mui/icons-material/Warning";
import clsx from "clsx";
import { useHistory } from "react-router-dom";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import styles from "./AddOperatives.module.css";
import {
  CustomFormGroup,
  ValidatingTextField,
} from "../../components/FormComponents";
import BackButton from "../../components/BackButton/BackButton";
import {
  MESSAGE_TYPE,
  RESOURCE_TYPE,
} from "../../constants";
import { withAllowedOperationsProvider } from "../../hocs";
import { CustomTab, Button, AuthChecker } from "../../atomicComponents";
import UserInfoPanel from "../../atomicComponents/UserInfoPanel/UserInfoPanel";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import TableSimple from "../../atomicComponents/TableSimple1/TableSimple";
import { setLogin } from '../../redux/features/auth/actions';
import { handleKeyPress, sanitizeCoCodeNumeric, sanitizeNumeric } from "../../utils/utils";
import useDebounceSearch from "../../hooks/useDebounceSearch";


const AddOperatives = () => {
  const history = useHistory();
  const { showPopup } = usePopupManager();
  const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
  const auth = useSelector((state) => state.auth); // useSelector
  const [flag, show] = useState(false);
  const [asnCount, setAsnCount] = useState(0);
  const [proDefDetails, setProDefDetails] = useState("");
  const [opDetails, setOpDetails] = useState("");
  let {
    userName,
    personNumber,
    companyCode,
    userRole,
    persArea,
  } = auth;
  const [savedData, setSaveData] = useState();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const dispatchNew= useDispatch();
  const [selectedProjectsDetails, setSelectedProjectsDetails] = useState([]);
  const [viewDisplay, setViewDisplay] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [ticketno, setTicketno] = useState("");
  const [operativeNumber, setOperativeNumber] = useState("");
  const [personName, setPersonName] = useState("");
  const [isPopupOpenFormModal, setPopupOpenFormModal] = useState(false);
  const handleOpenFormModal = () => {
    setPopupOpenFormModal(true);
  };
  const handleCloseFormModal = () => setPopupOpenFormModal(false);
  const [addNewRow, setAddNewRow] = useState([]);
  const [showSuperVisor,setShowSuperVisor] = useState(false)
  const [reseVC, setReseVC] = useState(false);
  const [dataDB, setDataDB] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [modifiedData, setModifiedData] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [addIndex,setAddIndex] = useState()
  const supSearch = useDebounceSearch(ticketno)
  const operativeSearch = useDebounceSearch(operativeNumber)
  const handleOpenVCResetModal = () => {
    setReseVC(true);
  };
  const handleCloseVCResetModal = () => setReseVC(false);
  const [myState, setState] = React.useState({
    checkFlag: false,
    SupervisorTicketNumber: "",
  });
 
  const handleCancelClick = () => {
    window.location.reload();
  };

  const handleViewbtn = async (e) => {
    if (e === "View") {
      setViewDisplay(true);
      setIsDelete(false);
    } else if (e === "Delete") {
      setViewDisplay(false);
      setIsDelete(true);
    }
    setState((prevState) => ({ ...prevState, tableFlag: true }));
    if(userRole.includes("S")){
      setShowSuperVisor(true)
    }
  }; 
  useEffect(()=>{
    if(showSuperVisor && userRole.includes("S") ){
      handleDisplaybtn(auth.personNumber)        
      setTicketno(personNumber);
      setPersonName(userName);
    }

  },[showSuperVisor,userRole])

  const handleSearchData = (event) => {
    const inputValue = event;
    if (/^\d*$/.test(inputValue)) {
   setTicketno(inputValue);
    }
    if (inputValue) {
      handleDisplaybtn(inputValue);
    }
    else{
      setPersonName('');
      setTableData([...tableData]);
      setDeleteTableData('');
      setSelectedProjectsDetails();
    }
    setProDefDetails(inputValue);
  };

  useEffect(()=>{
   handleSearchData(supSearch)
  },[supSearch])
  const handleKeyPressHandler = (e) => {
    handleKeyPress({
      event: e,                 
      callback: handleDisplaybtn 
    });
  };
 
const handleAddRow = (e,i) => {
  console.log('i value',i);
  
  const newRowValue = e?.target?.value?.trim();
  if (operativeSearch) {
    let apiFormatedData = {
      "supno": sanitizeNumeric(ticketno),
      "operativeno": newRowValue,
      "pers_parea": persArea,
      "pers_no": sanitizeNumeric(personNumber),
      "co_code": sanitizeCoCodeNumeric(companyCode),
    };

    let apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}master/addoperative`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:'include'
    })
      .then((response) => {
        dispatchNew(setLogin({ ...auth, recentStatus: response.status }));
        return response.json();
      })
      .then((responseJson) => {
        if(responseJson?.msg === 'Fail'){
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: responseJson.data,
          });
        }
        if (responseJson) {
          setAddNewRow(responseJson.data);
          if (i !== undefined) {
            if (responseJson.data[0].pers_no !== undefined || responseJson.data[0].complete_name !== undefined) {
              let items = [...tableData];
              let item = { ...items[i] };
              item.emp_tkt_no = responseJson.data[0].pers_no;
              item.complete_name = responseJson.data[0].complete_name;
              items[i] = item;
              setTableData([...items]);
            }
          } else {            
            setTableData([...tableData]);
          }
        }
      })
      .catch((error) => {
        console.error("API Error:", error); 
        showPopup({
          type: MESSAGE_TYPE.FAILURE,
          contextText: MESSAGE_TYPE.FAILURE,
          info: "Oops! Something went wrong. Please try again later",
        });
      });
  } else {
    setOperativeNumber(e?.target?.value); 
  }
};

useEffect(()=>{
   handleAddRow(operativeNumber ?? '',addIndex)
},[operativeSearch])

const handleDisplaybtn = async (TicketNo) => {
    setState((prevState) => ({ ...prevState, tableFlag: true }));
    let apiFormatedData = {
      supno: sanitizeNumeric(TicketNo),
    };
    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}master/DisplayOprative`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:'include'
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson.msg == 'Fail') {
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: responseJson.data,
            });
          }
          setPersonName(responseJson.data.supervisor_data[0].complete_name);
          setTableData(responseJson.data.operator_data);
          setDeleteTableData(responseJson.data.operator_data);
          setSelectedProjectsDetails(responseJson.data.operator_data)       
          if (responseJson.data.operator_data == undefined || responseJson.data.operator_data== 0){
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "No Active Operative linked",
            });
          }
        } else {
          showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: responseJson.data,
            });
        }
      })
      .catch((error) => {
        console.error(error)
      });
  };

  const handleSavebtn = async () => {
    setState((prevState) => ({ ...prevState, tableFlag: true }));
    if(tableData?.length == 0 || addNewRow?.length == 0)
    {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please add Operative Details",
      });
    }
    else{
    const newOpNumber=[];
    tableData?.map((info)=>{
      newOpNumber.push({
        supno:ticketno,
        operativeno:sanitizeNumeric(info.emp_tkt_no),
        pers_parea:persArea,
        pers_no:sanitizeNumeric(personNumber),
        co_code:sanitizeCoCodeNumeric(companyCode),

      })
    })

  var apiFormatedDataJson = JSON.stringify(newOpNumber);
    let headerss = new Headers(); 
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}master/insertoperative`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:'include'
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        
        if (responseJson) {   
          setSaveData(responseJson);
          if (responseJson.msg == "Success") {
            showPopup({
              type: MESSAGE_TYPE.SUCCESS,
              contextText: MESSAGE_TYPE.SUCCESS,
              info: responseJson.data,
              reloads:true, // Set reload to true or false based on your condition
 
            });
          }
        } else {
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "Error",
          });
        }
      })
      .catch((error) => {
        showPopup({
          type: MESSAGE_TYPE.FAILURE,
          contextText: MESSAGE_TYPE.FAILURE,
          info: "Oops! Something went wrong. Please try again later",
        });
      });
    setIsDelete();
    setDeleteTableData();
}
    

  };

  const updateFinalData = () => {
    const filteredData = modifiedData.filter(
      (item, index) => checkedItems[index] === true
    );
    setFinalData(filteredData);
  };
  
  useEffect(() =>{
    if (finalData?.length !== 0) {
      const resultList =  finalData.map((projectData) => (
        {
          "supno":sanitizeNumeric(ticketno),
          "operativeno": sanitizeNumeric(projectData.emp_tkt_no),
          "pers_parea":persArea,
          "pers_no":sanitizeNumeric(personNumber),
          "co_code":sanitizeCoCodeNumeric(companyCode),

        }
        ))
        setDataDB(resultList);
    }
  }, [finalData]);
  const handleSelectedProjectsChange = (newSelectedProjects) => {
    const newModifiedData = newSelectedProjects.map((item) => ({
      ...item,
    }));
    setModifiedData(newModifiedData);
  };

  useEffect(() => {
    if (selectedProjectsDetails?.length > 0) {
      handleSelectedProjectsChange(selectedProjectsDetails);
    }
  }, [selectedProjectsDetails]);

  useEffect(() => {
    if (checkedItems?.length != 0) {
      updateFinalData();
    }
  }, [checkedItems, modifiedData]);
  const handleDeleteBtn=()=>{
    
    if (finalData?.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select at least one Operator.",
        reloads:true,
      });
      return; // Stop further processing
    }else {      
      axios
        .post(`${baseUrl}master/deleteoperative`, dataDB,{
          headers: {
          'Content-Type': 'application/json',
          },
          withCredentials:true,
        })
        .then((res) => {
          dispatchNew(setLogin({...auth, recentStatus: res.status}))
          if (res.data.status=== "Operators Deleted Successfully...") {        
            showPopup({
              type: MESSAGE_TYPE.SUCCESS,
              contextText: MESSAGE_TYPE.SUCCESS,
              info: res.data.status,
              reloads:true, // Set reload to true or false based on your condition
            });       
          } else {
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "failed.",
            });
          }
        })
        .catch((error) => {
          dispatchNew(setLogin({...auth, recentStatus: error.response.status}))      
        });
    }
    setViewDisplay();
    setIsDelete();
    setDeleteTableData();
    setPersonName();
    }

  const redirectToApplicationLandingPage = () => {
    history.push("/home");
  };

  const renderHTML = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              style={{
                marginLeft: "21px",
                marginRight: "11px",
              }}
              defaultValue=""
              onClick={(e) => handleViewbtn(e.target.value)}
            >
              <FormControlLabel
                value="View"
                name="status"
                control={<Radio size="small" />}
                label="Add"
                onChange={(e) => setViewDisplay(true)}         
                className={styles.radiobtn}
              />
              <FormControlLabel
                value="Delete"
                name="status"
                control={<Radio size="small" />}
                label="Delete"
                onChange={(e) => setIsDelete(true)}
                className={styles.radiobtn}
              />
            </RadioGroup>
          </div>
        </Grid>
      </Grid>
    </div>
  );
  const initialTableDataDelete = [
    {
      ticket: "",
      empl_name: "",
      select: (<input type="checkbox" />),
    },
  ];
  const [tableData, setTableData] = useState([{
    emp_tkt_no: (
      <ValidatingTextField
        variant="outlined"
        size="small"
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleKeyPress({
              event:e,
              callback:handleAddRow
            })
          }
        }}      
        onChange={(e) => {
          handleAddRow(e)  
        }}
        
        name="Supervisor Ticket Number"
        inputProps={{
          "data-testid": "remark-input",
        }}
        style={{ width: "50%" }}
      />
    ),
    
    complete_name: addNewRow && addNewRow?.length >= 0 || "",
  }]);
  const [deleteTableData, setDeleteTableData] = useState([]);
 

  const handleCheckboxChange = (event, index) => {
    const { checked } = event.target;
    setCheckedItems((prevState) => ({
      ...prevState,
      [index]: checked,
    }));
    const updatedModifiedData = [...modifiedData];
    if (index >= 0 && index < updatedModifiedData?.length) {
      setModifiedData(updatedModifiedData);}

  };

  const addRow = (i) => {
        const newRow = {
      emp_tkt_no: (
        <ValidatingTextField
          variant="outlined"
          size="small"   
          onChange={(e) => {
            handleAddRow(e,i)
            setAddIndex(i)
            setOperativeNumber(e)
          }}         
          name="Supervisor Ticket Number"
          inputProps={{
            "data-testid": "remark-input",
          }}
          style={{ width: "100%" }}
        />
      ),
      
      complete_name: addNewRow && addNewRow.length >= 0 || "",
    };
    setTableData([...tableData, newRow]);
  };
  
  const renderOperativesDetails = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={5} lg={5} sm={12}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label> Supervisor Details</label>
            </div>
            <div className={styles.formDiv}>
              <ValidatingTextField
                isDisabled={userRole.includes("S")}
                variant="outlined"
                size="small"
                value={ticketno}
                onChange={(e)=>{
                  setTicketno(e.target.value)
                  handleSearchData()
                }}                     
                name="Supervisor Ticket Number"
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "50%" }}
              />
             
              <ValidatingTextField
                variant="outlined"
                size="small"
                value={personName}         
                name="Supervisor Ticket Number"
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </Grid>
      </Grid> 
      {personName && (

       <>
      <Grid
        container
        spacing={1}     
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={2} lg={2} xs={2} sm={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Oprative Details:</label>
            </div>
          </div>
        </Grid>
        <Grid item md={5} lg={5} xs={10} sm={10} >
          <div className={clsx(styles.scrollBar)}>
          <TableSimple       
            tableColumnData={tableData}
            tableHeaderLabel={["Ticket Number_40", "Employee Name_90"]}
            TableRowHederAling="center"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
          </div>      
          <Grid
            container
            spacing={1}
            className={styles.myGrid}
            style={{ marginTop: "10px" }}
            columns={12}
          >
            <Grid item md={3} lg={3}>
              <Button
                style={{ color: "black", backgroundColor: "#E6F2FF" }}
                data-testid="confirm-action"
                onClick={()=>{addRow(tableData?.length)}}
              >
                +
              </Button>
            </Grid>
          </Grid>
        
        {tableData.length !==0 &&
          <Grid
            container
            spacing={1}           
            style={{ marginTop: "10px" }}
            columns={12}
          >
            <Grid item md={2} lg={2} />

            <Grid item md={4} lg={4}>
              <div className={styles.rowDiv}>
                <div className={styles.formDiv}>
                  <Button
                    className={clsx(
                      styles.actionButton,
                      styles.primaryActionButton
                    )}
                    variant="primary"
                    onClick={() => handleSavebtn()}                 
                    data-testid="confirm-action"
                    disabled={tableData?.length === undefined}
                  >
                    Save
                  </Button>

                  <Button
                    className={clsx(styles.actionButton, styles.resetButton)}
                    variant="tertiary"
                    onClick={handleCancelClick}
                    data-testid="confirm-action"
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>}
        </Grid>
      </Grid></>)}
      

    </div>
  );

  const renderDeleteOperativesDetails = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={5} lg={5} sm={12}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Supervisor Details</label>
            </div>
            <div className={styles.formDiv}>
               <ValidatingTextField
                isDisabled={userRole.includes("S")}
                variant="outlined"
                size="small"
                value={ticketno}
                onChange={(e)=>{
                  setTicketno(e.target.value)
                  handleSearchData()
                }}
                name="Supervisor Ticket Number"
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "50%" }}
              />
              <ValidatingTextField
                variant="outlined"
                size="small"
                value={personName}
                name="Supervisor Employee Name"
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </Grid>
      </Grid>
   {ticketno && tableData?.length !== 0 &&
   <Grid
        container
        spacing={1}      
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={2} lg={2} xs={3} sm={3}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Operative Details:</label>
            </div>
          </div>
        </Grid>
        <Grid item md={6} lg={6} xs={9} sm={9}>
        <div className={clsx(styles.scrollBar)}>
          <TableSimple
            tableColumnData={selectedProjectsDetails?.map((info, index) => ({
              supno:info.emp_tkt_no,
              empl_name:info.complete_name,
              select: (
                <input
                  type="checkbox"
                  checked={checkedItems[index] || false}
                  onChange={(event) => handleCheckboxChange(event, index)}
                />
              ),

            }))}
            tableHeaderLabel={["Ticket Number_40", "Employee Name_90", "Select_30"]}
            TableRowHederAling="center"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
          </div>     
          <Grid
            container
            spacing={1}           
            style={{ marginTop: "10px" }}
            columns={12}
          >
            <Grid item md={2} lg={2} />

            <Grid item md={4} lg={4}>
              <div className={styles.rowDiv}>
                <div className={styles.formDiv}>
                  <Button
                    className={clsx(
                      styles.actionButton,
                      styles.primaryActionButton
                    )}
                    variant="primary"
                    onClick={() => handleDeleteBtn()}                
                    data-testid="confirm-action"
                  >
                    Delete 
                  </Button>

                  <Button
                    className={clsx(styles.actionButton, styles.resetButton)}
                    variant="tertiary"
                    onClick={handleCancelClick}
                    data-testid="confirm-action"
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
}
    </div>
  );

  return (
    <>
      <div className={styles.container} style={{ boxSizing: "border-box" }}>
        <div
          className={styles.backButtonLastRefreshedDateWrapper}
          style={{ display: "none" }}
        >
          <BackButton
            action="Home"
            handleClick={redirectToApplicationLandingPage}
          />
        </div>
        <div className={styles.processHeader}>
          <div className={styles.CustomTabClass}>
            <CustomTab title="Time Booking" withOutCount isSelected />
          </div>
          <div className={styles.processTopbar}>
            <UserInfoPanel
              userInfo={[
                {
                  Name: "Aditya Mathur",
                  "SAP ID": 122355,
                  "BC No": "122355",
                  LOC: "Engineering and Research Center",
                },
              ]}
            />
          </div>
        </div>

        <div
          className={clsx(
            styles.scrollContainer,
            styles.scrollBar,
            styles.formContainer
          )}
        >
          <CustomFormGroup
            header="Add / Delete Operatives"
            body={renderHTML()}
          />
          {viewDisplay === true &&           
            renderOperativesDetails()}
          {isDelete === true && renderDeleteOperativesDetails()}
        </div>

        {flag && (
          <div
            className={styles.tableView}
            style={{ height: "86%", padding: "0 2em" }}
          >       
          </div>
        )}
      </div>     
      <ResetModalVC
        isPopupOpen={reseVC}
        handleCloseVCModal={handleCloseVCResetModal}
        // resetVCCall={resetVCCall}
      />

      <ResetModalF
        isPopupOpen={isPopupOpenFormModal}
        handleCloseFormModal={handleCloseFormModal}
      />  
    </>
  );
};
function ResetModalVC({ isPopupOpen, handleCloseVCModal, resetVCCall }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <WarningIcon style={{ height: "18px", width: "18px" }} />
            <span style={{ marginLeft: "8px" }} className={styles.txt}>
              Confirm Reset
            </span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div>
            <p>
              On confirmation, Selected VC BoM will get reset and all changes
              made will be lost
            </p>

            <p>Are you sure ?</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCloseVCModal}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleCloseVCModal();
              resetVCCall();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}
function ResetModalF({ isPopupOpen, handleCloseFormModal, goNextForm }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <WarningIcon style={{ height: "18px", width: "18px" }} />
            <span style={{ marginLeft: "8px" }} className={styles.txt}>
              Confirm Submit
            </span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div>
            <p>On confirmation ,VC BoM data will submit</p>

            <p>Are you sure ?</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCloseFormModal}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleCloseFormModal();
              goNextForm();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

function ResetModal({ isPopupOpen, handleClose, goNext }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <WarningIcon style={{ height: "18px", width: "18px" }} />
            <span style={{ marginLeft: "8px" }} className={styles.txt}>
              Confirm file Upload
            </span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div>
            <p>On confirmation ,Records will be appended.</p>

            <p>Are you sure ?</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose();
              goNext();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

function ResetModal2({ isPopupOpen1, handleClose1, goNext1 }) {
  return (
    <Dialog
      open={isPopupOpen1}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <WarningIcon style={{ height: "18px", width: "18px" }} />
            <span style={{ marginLeft: "8px" }} className={styles.txt}>
              Selected data will be deleted
            </span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div>
            <p> On confirmation, Selected data will be deleted.</p>
            <p>Are you sure ?</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleClose1}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              goNext1();
              handleClose1();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  goNext: PropTypes.func.isRequired,
};
ResetModalF.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleCloseFormModal: PropTypes.func.isRequired,
  goNextForm: PropTypes.func.isRequired,
};
ResetModalVC.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleCloseVCModal: PropTypes.func.isRequired,
  resetVCCall: PropTypes.func.isRequired,
};

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  goNext: PropTypes.func.isRequired,
};
ResetModal2.propTypes = {
  isPopupOpen1: PropTypes.bool.isRequired,
  handleClose1: PropTypes.func.isRequired,
  goNext1: PropTypes.func.isRequired,
};

export default withAllowedOperationsProvider(
  AddOperatives,
  RESOURCE_TYPE.PROJECT
);